import { render, staticRenderFns } from "./PtInputColor.vue?vue&type=template&id=1c040363"
import script from "./PtInputColor.vue?vue&type=script&lang=js"
export * from "./PtInputColor.vue?vue&type=script&lang=js"
import style0 from "./PtInputColor.vue?vue&type=style&index=0&id=1c040363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports